var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAssetsIcon = function SvgAssetsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 15,
    fill: "#D8F0E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.592 14.389h8.075v-1.167c0-.644-.523-1.166-1.167-1.166h-3.889L14.056 10.5h-3.89C9.523 10.5 9 11.022 9 11.667v7.982l2.2-4.402a1.55 1.55 0 0 1 1.392-.858Zm9.608.778h-9.608a.775.775 0 0 0-.695.43L9 21.389h10.867a.778.778 0 0 0 .696-.43l2.333-4.667c.279-.518-.098-1.125-.696-1.125Z",
    fill: "#38A77A"
  })));
};

export { SvgAssetsIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzMCAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNS41IiByPSIxNSIgZmlsbD0iI0Q4RjBFNSIvPgo8cGF0aCBkPSJNMTIuNTkyNCAxNC4zODg5SDIwLjY2NjdWMTMuMjIyMkMyMC42NjY3IDEyLjU3ODEgMjAuMTQ0MSAxMi4wNTU2IDE5LjUgMTIuMDU1NkgxNS42MTExTDE0LjA1NTYgMTAuNUgxMC4xNjY3QzkuNTIyMzMgMTAuNSA5IDExLjAyMjMgOSAxMS42NjY3VjE5LjY0ODZMMTEuMjAwNiAxNS4yNDY5QzExLjQ2NDYgMTQuNzE5NCAxMS45OTkzIDE0LjM4ODkgMTIuNTkyNCAxNC4zODg5Wk0yMi4yMDAzIDE1LjE2NjdIMTIuNTkyNEMxMi4yOTgzIDE1LjE2NjcgMTIuMDI4NSAxNS4zMzE5IDExLjg5NzIgMTUuNTk2OUw5IDIxLjM4ODlIMTkuODY3QzIwLjE2MTYgMjEuMzg4OSAyMC40MzA5IDIxLjIyMjMgMjAuNTYyNiAyMC45NTg5TDIyLjg5NiAxNi4yOTIzQzIzLjE3NSAxNS43NzQzIDIyLjc5ODMgMTUuMTY2NyAyMi4yMDAzIDE1LjE2NjdaIiBmaWxsPSIjMzhBNzdBIi8+Cjwvc3ZnPgo=";